import { render, staticRenderFns } from "./OrderMenuCard.vue?vue&type=template&id=412e7f22&scoped=true"
import script from "./OrderMenuCard.vue?vue&type=script&lang=ts"
export * from "./OrderMenuCard.vue?vue&type=script&lang=ts"
import style0 from "./OrderMenuCard.vue?vue&type=style&index=0&id=412e7f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e7f22",
  null
  
)

export default component.exports